{ useState, useRef } = React
{ Button } = ReactComponents
{ useI18n, useCoffeeCallback } = require 'lib/react_utils'
ACPVisualGuidelinesActions = require 'actions/acp_visual_guidelines_actions'
ACPVisualGuidelinesStore = require 'stores/acp_visual_guidelines_store'
ConnectStore = require 'components/enhancers/connect_store'
DbHelper = require 'base/lib/db_helper'
Exceptions = require 'lib/exceptions'
ExportEmbeddableCodeDialog = require 'components/common/export_embeddable_code_dialog'
ExportModal = require 'components/dissemination/acp_visual_guidelines/export_modal'
SettingsModal = require 'components/dissemination/acp_visual_guidelines/settings_modal'
IconButton = require 'components/common/icon_button'
mediator = require 'mediator'

storeConnector =
  ACPVisualGuidelinesStore: (Store) ->
    isExportDialogOpen: Store.isExportDialogOpen()
    settingsDialog: Store.getSettingsDialogState()

VisualGuidelinesToolbar = ({
  isExportDialogOpen
  isSettingsDialogOpen
  itemId
  settingsDialog
  submoduleScreen
}) ->

  i18n = useI18n()

  [iframeCode, setIframeCode] = useState(null)
  [vcgUrl, setVcgUrl] = useState(null)
  [exportIsDone, setExportIsDone] = useState(false)
  createVisualization = useCoffeeCallback [], -> ACPVisualGuidelinesActions.openCreateOrEditDialog()

  onSave = useCoffeeCallback [], (settings) -> ACPVisualGuidelinesActions.saveSettings settings

  onExport = useCoffeeCallback [itemId], (options) ->

    { outputFormat } = options

    VIService = mediator.services.viService
    switch (outputFormat)
      when 'pdf'
        VIService.exportVIGuidelinesToPdf(itemId)
        .then (ACPVisualGuidelinesActions.closeExportDialog)
      when 'external_link'
        VIService.exportVIGuidelines(itemId)
        .then (ACPVisualGuidelinesActions.closeExportDialog)
        .catch (error) ->
          if error instanceof Exceptions.visual_guidelines_export_failed
            setVcgUrl error.url
            setExportIsDone true
            return
          throw error

      when 'external_embeddable_code'
        VIService.exportVi(itemId).then ({ url }) ->
          setIframeCode VIService.getEmbeddableHTML url
        .then (ACPVisualGuidelinesActions.closeExportDialog)

  <div className="flex flex-row mx-10 items-center">
    <h2 className="flex-grow">
      {i18n 'nav.dissemination_submodules.acp_visual_guidelines'}
    </h2>

    {switch submoduleScreen
      when 'details'
        <div>
          <div className="flex flex-row items-center vi-toolbar-icons">
            <IconButton
              className=""
              iconName="export"
              label={i18n('actions.export_vi')}
              labelPosition="right"
              onClick={ACPVisualGuidelinesActions.openExportDialog}
            />
            <IconButton
              className="ml-10"
              iconName="settings"
              label={i18n('vi:labels.settings')}
              labelPosition="right"
              onClick={ACPVisualGuidelinesActions.openSettingsDialog}
            />
          </div>
          <SettingsModal
            isOpen={settingsDialog.get('isOpen')}
            settings={settingsDialog.get('settings')}
            onClose={ACPVisualGuidelinesActions.closeSettingsDialog}
            onSave={onSave}
          />
          <ExportModal
            url={vcgUrl}
            isOpen={isExportDialogOpen}
            onClose={->
              setExportIsDone false
              setVcgUrl null
              ACPVisualGuidelinesActions.closeExportDialog()
            }
            exportIsDone={exportIsDone}
            onExport={onExport}
          />
          <ExportEmbeddableCodeDialog
            isOpen={not _.isEmpty(iframeCode)}
            code={iframeCode}
            onClose={() -> setIframeCode(null)}
          />
        </div>
      when 'list'
        <div>
          <div className="flex flex-row items-center">
            <Button
              className="btn btn-apply"
              label={i18n 'actions.create_visualization'}
              onClick={createVisualization}
            />
          </div>
        </div>
    }
  </div>

VisualGuidelinesToolbar.propTypes =
  itemId: PropTypes.string
  isExportDialogOpen: PropTypes.bool.isRequired
  submoduleScreen: PropTypes.oneOf(['details', 'list']).isRequired

VisualGuidelinesToolbar.defaultProps =
  itemId: null
  submoduleScreen: 'list'

module.exports = ConnectStore VisualGuidelinesToolbar, [ACPVisualGuidelinesStore], storeConnector
